import React from "react";
import { Pagination, PaginationItem } from "@mui/material";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";

interface ModernPaginationProps {
    totalPages: number;
    pageNumber: number;
    handlePageChange: (event: React.ChangeEvent<unknown>, page: number) => void;
}

export const ModernPagination: React.FC<ModernPaginationProps> = ({
    totalPages,
    pageNumber,
    handlePageChange,
}) => {
    return (
        <Pagination
            count={totalPages}
            page={pageNumber}
            onChange={handlePageChange}
            variant="outlined"
            shape="rounded"
            renderItem={(item) => (
                <PaginationItem
                    slots={{ previous: ChevronLeft, next: ChevronRight }}
                    {...item}
                    sx={{
                        border: "1px solid #E5E7EB",
                        color: "#374151",
                        fontWeight: 500,
                        margin: "0 2px",
                        minWidth: "36px",
                        height: "36px",
                        borderRadius: "8px",
                        fontSize: "14px",
                        transition: "all 0.2s ease",
                        "&:hover": {
                            backgroundColor: "#F3F4F6",
                            borderColor: "#D1D5DB",
                        },
                        "&.Mui-selected": {
                            backgroundColor: "#3A80F4",
                            color: "white",
                            borderColor: "#3A80F4",
                            fontWeight: 600,
                            "&:hover": {
                                backgroundColor: "#2563EB",
                                borderColor: "#2563EB",
                            },
                        },
                        "&.Mui-disabled": {
                            color: "#D1D5DB",
                            borderColor: "#F3F4F6",
                        },
                    }}
                />
            )}
            sx={{
                "& .MuiPagination-ul": {
                    flexWrap: "nowrap",
                    gap: "2px",
                },
            }}
        />
    );
};

